'use strict';

angular.module('chatEngine.contactSettings',
    [
        'chatEngine.dialog',
        'chatEngine.mixpanel',
        'chatEngine.services'
    ])
.controller('ContactSettingsCtrl', ['$scope', '$http', 'Dialog', 'mixpanelService', '$location', 'alertService',
    function($scope, $http, Dialog, mixpanelService, $location, alertService) {
    mixpanelService.forceTrack('Contact Setting Show');
    $scope.contact = {
        full_name: '',
        email: '',
        apple_developer_id: '',
        receive_updates: '',
        tos_accepted: true
    };
    $scope.alertData = alertService.getAlertData();

    $http.get('/api/v1/session')
    .success(function(data) {
        $scope.userId = data.username;
        if (!$scope.userId) {
            $location.path('/home');
            return;
        }
    })
    .error(function() {
        $location.path('/home');
        return;
    });

    $scope.showTosButtons = false;
    $scope.loaded = false;
    var fields = ['full_name', 'email', 'apple_developer_id', 'receive_updates'];

    $http.get('/api/v1/contact')
        .error(function() {
            Dialog.alert('Error', 'An error occurred while loading your information.');
        })
        .success(function(response) {
            $scope.contact = response;
            $scope.loaded = true;
            $scope.showTosButtons = !$scope.contact.tos_accepted;
        });

    $scope.isLoading = function() {
        return !$scope.loaded;
    };

    $scope.saveContact = function() {
        if($scope.showTosButtons) {
            mixpanelService.forceTrack('TOS Accept & Continue Click');
        } else {
            mixpanelService.forceTrack('Contact Settings Edit Save Click');
        }
        var data = {};
        if(!$scope.contact.full_name || !$scope.contact.email) {
            Dialog.alert('Error', 'Your information is incomplete.');
            return;
        }
        fields.forEach(function(fieldId) {
            data[fieldId] = $scope.contact[fieldId] || null;
        });

        $http.patch('/api/v1/contact', data)
        .success(function() {
            alertService.setShowAppleIdAlert(!$scope.contact.apple_developer_id);

            if($scope.showTosButtons) {
                $scope.showTosButtons = false;
                $scope.accept();
            } else if ($location.url() === '/tos') {
                $location.path('/reporting');
            }
        })
        .error(function() {
            Dialog.alert('Error', 'An error occurred while saving your information. Please verify that you\'ve ' +
                'entered the correct information');
        });
    };

    $scope.cancelContact = function() {
        if($scope.showTosButtons) {
            $scope.decline();
        } else {
            mixpanelService.forceTrack('Contact Settings Edit Cancel Click');
            if ($location.url() === '/tos') {
                $location.path('/reporting');
            }
        }
    };

    var validatorMap = {
        full_name: function(s) {
            return s !== null;
        },
        email: function(s) {
            // basic email address validation
            var re = /^(\S+)@(\S+)\.(\S+){2,}$/;
            return re.test(s);
        },
        apple_developer_id: function(s) {
            // Apple Developer Team ID
            var re = /^[a-zA-Z0-9]{10}$/;
            return re.test(s);
        }
    };

    $scope.isFieldValid = function(field) {
        var validator = validatorMap[field];
        if(!validator) {
            return true;
        }
        if($scope.contact[field]) {
            var value = $scope.contact[field];
            return validator(value);
        } else {
            return false;
        }
    };
}]);
